export enum ModuleNames {
  Module1 = "Module1",
  Module2 = "Module2"
}
